import { tracerWith as tracerWith$1 } from '../../internal/defaultServices.esm.js';
import { TracerTypeId as TracerTypeId$1, tracerTag, make as make$1, externalSpan as externalSpan$1 } from '../../internal/tracer.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 */
const TracerTypeId = TracerTypeId$1;

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category tags
 */
const Tracer = tracerTag;

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const externalSpan = externalSpan$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const tracerWith = tracerWith$1;

export { Tracer, TracerTypeId, externalSpan, make, tracerWith };
